import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCheckboxdropdownComponent } from './custom-checkboxdropdown.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from "@angular/material/icon";



@NgModule({
  declarations: [
    CustomCheckboxdropdownComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule
],
   exports:[
    CustomCheckboxdropdownComponent
    ]
})
export class CustomCheckboxdropdownModule { }
